/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nolistingsyet2Inputs */

const en_nolistingsyet2 = /** @type {(inputs: Nolistingsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listings yet`)
};

const de_nolistingsyet2 = /** @type {(inputs: Nolistingsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Orte`)
};

/**
* | output |
* | --- |
* | "No listings yet" |
*
* @param {Nolistingsyet2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nolistingsyet2 = /** @type {((inputs?: Nolistingsyet2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nolistingsyet2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nolistingsyet2(inputs)
	return de_nolistingsyet2(inputs)
});
export { nolistingsyet2 as "noListingsYet" }